export enum TextOverflow {
    clip,
    ellipsis,
    inherit,
    initial,
    unset
}